import { render, staticRenderFns } from "./ProductDetailsPARA.vue?vue&type=template&id=715602c8&scoped=true"
import script from "./ProductDetailsPARA.vue?vue&type=script&lang=js"
export * from "./ProductDetailsPARA.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailsPARA.vue?vue&type=style&index=0&id=715602c8&prod&lang=scss&scoped=true"
import style1 from "./ProductDetailsPARA.vue?vue&type=style&index=1&id=715602c8&prod&lang=scss"
import style2 from "./ProductDetailsPARA.vue?vue&type=style&index=2&id=715602c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715602c8",
  null
  
)

export default component.exports